<template>
  <div class="transparency">
    <el-card class="letter-chat">
      <div slot="header">
        <span>{{title}}</span>
        <el-link class="letter-close-chat" @click="close_letter_chat" :underline="false"><i class="el-icon-close"></i></el-link>
      </div>
      <div>
        <el-alert :title="tipTitle" type="info" :closable="false"></el-alert>
        <div class="webLetterInput">
          <el-form label-position="top" label-width="80px" :model="data">
            <el-form-item :label="phoneLabel">
              <el-input v-model="data.phone"></el-input>
            </el-form-item>
            <el-form-item :label="contentLabel">
              <el-input
                  type="textarea"
                  rows="4"
                  :placeholder="contentPlaceholder"
                  v-model="data.content">
              </el-input>
            </el-form-item>
          </el-form>
          <el-button @click="postLetter" style="width: 100%;margin-top: 20px" type="primary">{{buttonTitle}}</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "webLetterInput",
  data() {
    return {
      teamID: '',
      UUID: '',
      loading: false,
      data: {
        'phone': '',
        'content':''
      },
      title: '离线请留言',
      tipTitle: '由于客服没有在线，不能提供在线服务，有问题可以给我们留言！',
      winLong: 0,
      phoneLabel: '电话',
      contentLabel: '留言内容',
      contentPlaceholder: '请输入内容',
      buttonTitle: '提交'
    }
  },
  mounted() {
    this.teamID = this.$route.query.teamID
    this.YQToken = this.$route.query.YQToken
    this.getLetterInfo()
  },
  methods:{
    //获取账号信息
    getLetterInfo()
    {
      this.$https({url: 'letterInfo?teamID='+this.teamID,method: "get"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.winLong = backData.data.data.winLong;
          if (this.winLong == 0) {
            this.title = '离线请留言'
            this.tipTitle = '由于客服没有在线，不能提供在线服务，有问题可以给我们留言！'
            this.phoneLabel = '电话'
            this.contentLabel = '留言内容'
            this.contentPlaceholder = '请输入内容'
            this.buttonTitle = '提交'
          } else {
            this.title = 'Offline, please leave a message'
            this.tipTitle = 'Due to customer service not being online, we are unable to provide online services. If you have any questions, please leave us a message！'
            this.phoneLabel = 'phone'
            this.contentLabel = 'message'
            this.contentPlaceholder = 'Please enter the content'
            this.buttonTitle = 'submit'
          }
        }
      });
    },
    postLetter()
    {
      this.data.teamID = this.teamID
      this.data.YQToken = this.YQToken
      this.$https({url: 'LeavingMsg',data:this.data,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.data = {}
          this.$notify({
            message: '留言保存成功！',
            type: 'success'
          });
        }
        if (backData.data.status === 201)
        {
          this.data = {}
          this.$notify({
            message: '留言参数不能为空！',
            type: 'warning'
          });
        }
      });
    },
    //关闭窗口
    close_letter_chat()
    {
      let data = {
        code : '200',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    }

  },
}
</script>

<style>
.webLetterInput{
  margin: 0 20px;
}
.webLetterInput .el-form-item{
  margin: 0;
}
.transparency{
  height: 100vh;
}
.letter-chat{
  height: 100%;
}
.letter-chat .el-card__header{
  padding: 10px;
}
.letter-chat .el-card__body{
  padding: 0;
}
.letter-close-chat{
  float: right;
  font-size: 23px;
  margin-top: -5px;
}





</style>



// WEBPACK FOOTER //
// src/components/letter/letterInput.vue